import React, { useEffect, useState } from 'react';
import { getInsightActions } from '../../services/summaryService';
import { BsSend } from 'react-icons/bs';
import parse from 'html-react-parser';
import config from '../../configs/config';
import { HTMLformatter, HTMLremover } from '../../functions/commonFunctions';
import { getAnomalyList } from '../../services/anomalyService';

const InsightsActions = (props) => {
  const [insights, setInsights] = useState([]);
  const [loader, setLoader] = useState(true);
  // console.log(insights)
  useEffect(() => {
    async function getData() {
      try {
        setLoader(true);
        const { data } = await getAnomalyList(0, 11, {
          // rca_present: true,
          anomaly_id: [
            '2025-02-01--*--annualized_premium_anp-*-Online-*-Life--*--proactive',
            '2025-02-01--*--annualized_premium_anp-*-Kowloon-**-New Policy-*-Health--*--predictive',
            '2025-02-01--*--annualized_first_year_commission_afyc-*-Renewal Policy--*--proactive',
            '2025-02-01--*--number_of_policies_nop-*-Agent 202--*--proactive',
            '2025-02-01--*--annualized_premium_anp-*-Hong Kong Island-*-Central and Western Hong Kong Island--*--proactive',
            '2025-02-01--*--annualized_premium_anp-*-New Policy--*--predictive',
            '2025-02-01--*--conversion_rate-*-New Policy--*--proactive',
            '2025-02-01--*--conversion_rate-*-New Policy-*-Property-Home--*--proactive',
            '2025-02-01--*--conversion_rate-*-Agent 202--*--proactive',
            '2025-02-01--*--annualized_first_year_commission_afyc-*-Agent 192--*--proactive',
            '2025-02-01--*--annualized_premium_anp-*-Agent 200--*--proactive'
          ]
        });

        setInsights(data);
        setLoader(false);
      } catch (err) {
        setLoader(false);
        console.log(err);
      }
    }
    getData();
  }, []);

  const submitQuery = (query, type, id) => {
    window.location =
      (config.prefix ? '/' + config.prefix_name : '') +
      '/chat?query=' +
      query.replaceAll('%', ' percentage') +
      '&type=' +
      type +
      '&id=' +
      id;
  };

  // Component - Placeholder
  const PlaceHolder = (key) => {
    return (
      <div className='d-flex' key={key}>
        <div className='flex-fill'>
          <p className='placeholder-glow mb-2'>
            <span
              className='placeholder col-12 insight-placeholder-card'
              style={{ borderRadius: '0.5rem' }}
            ></span>
          </p>
        </div>
      </div>
    );
  };

  return (
    <div className='place-container'>
      <h5 className='mb-4'>Insights</h5>
      <div className='insights-actions'>
        {!loader &&
          insights.length > 0 &&
          insights.map((x, i) => {
            return (
              <div className='insight-card' key={i}>
                <div className={`insight-type ${x.anomaly_type}`}>
                  {x.anomaly_type}
                </div>
                <div className='insight'>
                  {parse(HTMLformatter(x.inference))}
                </div>
                <div
                  className='open-chat'
                  onClick={() =>
                    submitQuery(
                      'Explain why ' + HTMLremover(x.inference),
                      'alert',
                      x.anomaly_id
                    )
                  }
                >
                  Open in Chat <BsSend />
                </div>
              </div>
            );
          })}
        {!loader && insights.length === 0 && (
          <div className='no-data'>No Insights found</div>
        )}
        {loader && (
          <div className='loader'>
            {[...Array(5).keys()].map((x) => {
              return PlaceHolder(x);
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default InsightsActions;
